// Commandes slash pour VoaChat (style Slack/Discord)
// Toutes les commandes transforment le texte AVANT envoi : pas de backend nécessaire.

export const SLASH_COMMANDS = [
  {
    name: "help",
    args: "",
    desc: "Affiche toutes les commandes disponibles",
    exec: () => {
      const lines = SLASH_COMMANDS.map(c => `• /${c.name}${c.args ? " " + c.args : ""} — ${c.desc}`).join("\n");
      return `🤖 **Commandes VoaChat** :\n${lines}`;
    },
  },
  {
    name: "me",
    args: "action",
    desc: "Action à la 3ème personne (ex: /me danse 💃)",
    exec: (args, ctx) => `*${ctx.userName || "Quelqu'un"} ${args || "fait quelque chose"}*`,
  },
  {
    name: "poll",
    args: "Question? opt1/opt2/opt3",
    desc: "Crée un sondage rapide (vote par emoji)",
    exec: (args) => {
      if (!args) return "/poll Question? opt1/opt2 — exemple : /poll Pizza ou Romazava? Pizza/Romazava";
      const qmIdx = args.indexOf("?");
      const question = qmIdx > 0 ? args.slice(0, qmIdx + 1) : args.split("/")[0];
      const rest = qmIdx > 0 ? args.slice(qmIdx + 1).trim() : args.split("/").slice(1).join("/");
      const options = rest.split("/").map(s => s.trim()).filter(Boolean).slice(0, 6);
      const emojis = ["1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣"];
      const lines = options.length
        ? options.map((opt, i) => `${emojis[i]} ${opt}`).join("\n")
        : "Ajoute des options séparées par /";
      return `📊 **Sondage** : ${question}\n${lines}\n_Réagis avec l'emoji correspondant !_`;
    },
  },
  {
    name: "8ball",
    args: "question?",
    desc: "Magic 8-ball — la boule magique répond",
    exec: (args) => {
      const answers = [
        "🎱 C'est certain", "🎱 Sans aucun doute", "🎱 Oui, absolument",
        "🎱 Peut-être bien", "🎱 Mes sources disent oui", "🎱 Probablement",
        "🎱 Réponse floue, réessaie", "🎱 Demande plus tard", "🎱 Mieux vaut ne pas répondre",
        "🎱 Très peu probable", "🎱 Mes sources disent non", "🎱 Non",
      ];
      const q = args || "(pas de question)";
      return `🎱 **${q}**\n→ ${answers[Math.floor(Math.random() * answers.length)]}`;
    },
  },
  {
    name: "coinflip",
    args: "",
    desc: "Pile ou face",
    exec: () => Math.random() < 0.5 ? "🪙 **Pile !**" : "🪙 **Face !**",
  },
  {
    name: "dice",
    args: "[faces]",
    desc: "Lance un dé (défaut: 6 faces, ex: /dice 20)",
    exec: (args) => {
      const faces = Math.max(2, Math.min(1000, parseInt(args, 10) || 6));
      const roll = 1 + Math.floor(Math.random() * faces);
      return `🎲 Tu as lancé un dé à ${faces} faces → **${roll}**`;
    },
  },
  {
    name: "shrug",
    args: "",
    desc: "Le célèbre ¯\\_(ツ)_/¯",
    exec: (args) => `¯\\_(ツ)_/¯${args ? " " + args : ""}`,
  },
];

const COMMAND_MAP = Object.fromEntries(SLASH_COMMANDS.map(c => [c.name, c]));

/**
 * Si le texte commence par `/cmd`, exécute la commande et retourne le résultat
 * (le texte transformé qui sera posté). Sinon retourne `null`.
 *
 * ctx : { userName: string }
 */
export function processSlashCommand(text, ctx = {}) {
  if (!text || !text.startsWith("/")) return null;
  const space = text.indexOf(" ");
  const name = (space === -1 ? text.slice(1) : text.slice(1, space)).toLowerCase();
  const args = space === -1 ? "" : text.slice(space + 1).trim();
  const cmd = COMMAND_MAP[name];
  if (!cmd) return null;
  try {
    return cmd.exec(args, ctx);
  } catch {
    return null;
  }
}

// Suggère les commandes qui commencent par `query` (sans le /)
export function suggestSlashCommands(query) {
  const q = (query || "").toLowerCase();
  return SLASH_COMMANDS.filter(c => c.name.startsWith(q)).slice(0, 8);
}
